import Vue from 'vue';
import App from './App.vue';
import store from './store/';
import router from './router/';
import {
    Dialog,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Input,
    Checkbox,
    CheckboxGroup,
    Select,
    Option,
    Button,
    Table,
    TableColumn,
    Popover,
    Tooltip,
    Form,
    FormItem,
    Tabs,
    TabPane,
    Slider,
    Icon,
    Upload,
    Link,
    Backtop,
    Message,
    MessageBox,
    Badge,
    Collapse,
    CollapseItem,
    Radio,
    RadioGroup,
    Autocomplete,
    Loading,
} from 'element-ui';
import * as Sentry from '@sentry/vue';
// @ts-ignore
import lang from 'element-ui/lib/locale/lang/en';
// @ts-ignore
import locale from 'element-ui/lib/locale';
import './assets/scss/style.scss';
import VueCookies from 'vue-cookies';
import { Component } from 'vue-property-decorator';

// configure language
locale.use(lang);

Vue.use(VueCookies);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Upload);
Vue.use(Link);
Vue.use(Backtop);
Vue.use(Badge);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Autocomplete);
Vue.use(Loading);

Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

Vue.use(VueCookies);

// Register the router hooks with their names
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);

Vue.config.productionTip = false;

Sentry.init({
    Vue: Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
    ],
});

new Vue({
    store,
    router,
    render: (h) => h(App),
}).$mount('#app');
